import { makeStyles, TextField } from '@material-ui/core';
import FlagstoneTheme from '../../../config/flagstoneTheme';
import { dataService } from '../../../services/data/data.service';
import { toast } from 'react-toastify';
import BackNextButton from '../../../base/buttons/backNextButton';

export default function SelectPathToSQLComponent(props) {

    const classes = useStyles();

    const pathChanged = (event) => {
        props.changePath(event.target.value)
    }

    const getSQLFiles = () => {
        dataService.getSQLFiles(props.path, props.env.connectionString).then(
            result => {
                if (result.ok) {
                    props.changeSqlFiles(result.data)
                    props.setNext();
                }
                else {
                    toast.error(result.error, { position: toast.POSITION.TOP_CENTER })
                }
            }
        )
    }

    return (

        <div className={classes.container}>
            <div className={classes.title}>
                Enter path to SQL files:
            </div>
            <TextField id="outlined-search" label="" type="search" variant="outlined" value={props.path} className={classes.uiTextField} size="small" onChange={(e) => pathChanged(e)} />
            <div className={classes.buttons}>
                <BackNextButton action={props.setPrevious}></BackNextButton>
                <BackNextButton next action={getSQLFiles}></BackNextButton>
            </div>

        </div>
    )
}

const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "500px",
        width: "50%",

    },
    uiTextField: {
        backgroundColor: "white",
        width: "100%",
        alignSelf: "center",
        marginTop: "30px"
    },
    title: {
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        fontSize: "22px",
    },
    nextButton: {
        border: "none",
        outline: "none",
        cursor: "pointer",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        marginTop: "30px",
        color: "white",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        fontSize: "18px",
        width: "150px",
        height: "40px"

    },
    buttons:{
        display:"flex",
        flexDirection:"row",
        width:"100%",
        justifyContent:"space-between"

    }

});